var map = {
	"./lend_btc.svg": 135,
	"./lend_eth.svg": 136,
	"./lend_jst.svg": 137,
	"./lend_sunold.svg": 138,
	"./lend_trx.svg": 139,
	"./lend_tusd.svg": 140,
	"./lend_usdj.svg": 141,
	"./lend_usdt.svg": 142,
	"./lend_wbtt.svg": 143,
	"./lend_win.svg": 144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 446;